/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

const FcsPermissionHydra = {
  cargo_flight_priority_sorting_enabled: new FcsFlag.Flag(false)
};

export const FlagsPermissionHydra = {
  ...FcsPermissionHydra
};

export function initFlagsHydra() {
  // register flags with namespaces for better grouping
  FcsFlag.register("hydra", FcsPermissionHydra);
}